import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type userOwnTractorSurveyStateType = {
  isFromJoinCompletePage?: boolean;
  isOwnTractorSurveyStartedProperly: boolean;
  ownTractorIdForEdit?: string;
  isApprovedTractor?: boolean;
  marketPrice?: number;
  brand?: string;
  brandId?: string;
  model?: string;
  engineOutputInPs?: number;
  manufacturedYear?: number;
  operationTime?: number;
};

const initialState: userOwnTractorSurveyStateType = {
  isFromJoinCompletePage: false,
  isOwnTractorSurveyStartedProperly: false,
  ownTractorIdForEdit: undefined,
  isApprovedTractor: false,
  marketPrice: undefined,
  brand: undefined,
  brandId: undefined,
  model: undefined,
  engineOutputInPs: undefined,
  manufacturedYear: undefined,
  operationTime: undefined,
};

export const userOwnTractorSurveySlice = createSlice({
  name: 'userOwnTractorSurvey',
  initialState,
  reducers: {
    resetState: (state) => {
      state.isOwnTractorSurveyStartedProperly = false;
      state.ownTractorIdForEdit = undefined;
      state.isApprovedTractor = false;
      state.marketPrice = undefined;
      state.brand = undefined;
      state.brandId = undefined;
      state.model = undefined;
      state.engineOutputInPs = undefined;
      state.manufacturedYear = undefined;
      state.operationTime = undefined;
    },

    changeIsFromJoinCompletePage: (state, action: PayloadAction<boolean>) => {
      state.isFromJoinCompletePage = action.payload;
    },

    changeIsOwnTractorSurveyStartedProperly: (state, action: PayloadAction<boolean>) => {
      state.isOwnTractorSurveyStartedProperly = action.payload;
    },

    changeOwnTractorSurveyForEdit: (
      state,
      action: PayloadAction<Omit<userOwnTractorSurveyStateType, 'isOwnTractorSurveyStartedProperly'>>,
    ) => {
      state.ownTractorIdForEdit = action.payload.ownTractorIdForEdit;
      state.isApprovedTractor = action.payload.isApprovedTractor;
      state.marketPrice = action.payload.marketPrice;
      state.brand = action.payload.brand;
      state.brandId = action.payload.brandId;
      state.model = action.payload.model;
      state.engineOutputInPs = action.payload.engineOutputInPs;
      state.manufacturedYear = action.payload.manufacturedYear;
      state.operationTime = action.payload.operationTime;
    },

    changeOwnTractorSurvey: (
      state,
      action: PayloadAction<
        Omit<userOwnTractorSurveyStateType, 'isOwnTractorSurveyStartedProperly' | 'ownTractorIdForEdit' | 'marketPrice'>
      >,
    ) => {
      state.brand = action.payload.brand;
      state.brandId = action.payload.brandId;
      state.model = action.payload.model;
      state.engineOutputInPs = action.payload.engineOutputInPs;
      state.manufacturedYear = action.payload.manufacturedYear;
      state.operationTime = action.payload.operationTime;
    },
  },
});
